import request from "root/js/request";

export const postDownloadCostExample = async ({ shares_id, cabinet_id }) => {
  const response = await request({
    url: `/analytics/shares_products/export/?cabinet_id=${cabinet_id}&shares_id=${shares_id}`,
    method: "post",
  });
  return response.data;
};
